module.exports = __webpack_public_path__ + "img/closed_handle_box1.d0e012bf.png";